import React from 'react';
import noun_account_213364 from '../../assets/images/noun_account_213364.png';
import dollars from '../../assets/images/dollars.png';
import layer_31 from '../../assets/images/layer_31.png';
import starsmart_object from '../../assets/images/starsmart_object.png';
import { useAuth } from "../../hooks/customers/AuthProvider";
import { Trans } from 'react-i18next';

function Head(props) {
  const auth = useAuth();

  return (

    <div className="row-2">
      <div className="l-constrained-2 group">
        <div className="heads_d">
          <div className="heads_d_1">
            <img src={starsmart_object} className="mob_hide starsmart_object" alt="starsmart_object" />
            <p className="mob_hide text-bf">BF</p>
          </div>
          <div className="heads_d_1">
            <img src={noun_account_213364} className="mob_hide noun_account_213364" alt="noun_account_213364" width="21" height="21" />
            <p className="mob_hide text">{auth.customer.company}</p>
          </div>
          {auth.customer.enable_wallet == 1 && (
            <div className="heads_d_1">
              <img src={dollars} className="mob_hide layer-31" alt="fruit" width="14" height="25" />
              <p className="mob_hide text-2">${Number(auth.customer.wallet_amount || 0).toFixed(2)}</p>
            </div>
          )}
        </div>
        <p className="text-3"> <Trans
          i18nKey="b2b_online_grocer_txt"
          components={{ span: <span /> }}
        /> </p>
        <div className="hambur_menu" onClick={props.menuClick}>
          <div className="rounded-rectangle-2"></div>
          <div className="rounded-rectangle-2-copy"></div>
          <div className="rounded-rectangle-2-copy-2"></div>
        </div>
      </div>
    </div>

  );
}

export default Head;
